import React, {useMemo} from "react";
import { Table} from "react-bootstrap";
import { FaArrowRight } from "react-icons/fa";

import {useConfigLog} from "./queries";
import dayjs from "dayjs";

export type ValueChange = {
    key: string;
    oldValue: any;
    newValue: any;
};

// Helper function to format dynamic values for display
const formatValue = (value: any): string => {
    if (value === null || value === undefined) {
        return 'null';
    }
    if (value === '') {
        return '(empty)';
    }
    if (typeof value === 'object') {
        // Handle arrays and objects by JSON stringifying
        return JSON.stringify(value);
    }
    // Handle primitives (string, number, boolean)
    return String(value);
};

export const LegacyConfigLog = () => {
    const { data: configLog } = useConfigLog();

    const configLogWithValueChanges = useMemo(() => {
        if (!configLog) {
            return [];
        }

        return configLog.map(log => ({
            ...log,
            companyCode: log.companyCode,
            takeAction: log.takeAction,
            createdBy: log.createdBy,
            createdOn: log.createdOn,
            valueChanges: (log.valueChanges)
                ? JSON.parse(log.valueChanges) as ValueChange[]
                : [],
        }));
    }, [configLog]);

    return (
        <div className="master-data-content tw-flex tw-flex-1 tw-flex-col">
            <div className="tw-flex tw-justify-between">
                <div className="trapezoid-head tw-w-fit">
                    <span>Config Log</span>
                </div>
            </div>

            <div className="mat-box tw-flex tw-flex-1 tw-flex-col">
                <div className="tw-flex-1">
                    <Table
                        size="sm"
                        className="table-bordered table-auto align-middle"
                    >
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>SID</th>
                                <th>Company Code</th>
                                <th>Module</th>
                                <th>Legacy ID</th>
                                <th>Action</th>
                                <th>Created By</th>
                                <th>Created On</th>
                                <th>Value Changes</th>
                            </tr>
                        </thead>
                        <tbody>
                            {configLogWithValueChanges.map(log => (
                                <React.Fragment key={log.id}>
                                    <tr>
                                        <td
                                            rowSpan={(log.valueChanges?.length || 0) + 1}
                                            className="tw-text-center align-middle"
                                        >
                                            {log.id}
                                        </td>
                                        <td
                                            rowSpan={(log.valueChanges?.length || 0) + 1}
                                            className="tw-text-center align-middle"
                                        >
                                            {log.sid}
                                        </td>
                                        <td rowSpan={(log.valueChanges?.length || 0) + 1}
                                            className="tw-text-center align-middle"
                                        >
                                            {log.companyCode}
                                        </td>
                                        <td
                                            rowSpan={(log.valueChanges?.length || 0) + 1}
                                            className="tw-text-center align-middle"
                                        >
                                            {log.resource}
                                        </td>
                                        <td
                                            rowSpan={(log.valueChanges?.length || 0) + 1}
                                            className="tw-text-center align-middle"
                                        >
                                            {log.module}
                                        </td>
                                        <td
                                            rowSpan={(log.valueChanges?.length || 0) + 1}
                                            className="tw-text-center align-middle"
                                        >
                                            {log.takeAction}
                                        </td>
                                        <td
                                            rowSpan={(log.valueChanges?.length || 0) + 1}
                                            className="tw-text-center align-middle"
                                        >
                                            {log.createdBy}
                                        </td>
                                        <td
                                            rowSpan={(log.valueChanges?.length || 0) + 1}
                                            className="tw-text-center align-middle"
                                        >
                                            {dayjs(log.createdOn).format('DD/MM/YYYY HH:mm:ss')}
                                        </td>
                                    </tr>
                                    {log.valueChanges.map(valueChange => (
                                        <tr key={valueChange?.key}>
                                            <td>
                                                <div className="tw-flex tw-items-center tw-gap-4">
                                                    <span className="tw-font-semibold">{valueChange.key}</span>
                                                    <span className="tw-bg-red-100 tw-rounded-sm tw-px-1 tw-py-0.5">
                                                        {formatValue(valueChange?.oldValue)}
                                                    </span>
                                                    <FaArrowRight />
                                                    <span className="tw-bg-green-100 tw-rounded-sm tw-px-1 tw-py-0.5">
                                                        {formatValue(valueChange?.newValue)}
                                                    </span>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </React.Fragment>
                            ))}
                        </tbody>
                    </Table>
                </div>
            </div>
        </div>
    );
};
